const trimTrailingSlashes = (value = "") => String(value || "").replace(/\/+$/, "");

export const getRealtimeRelayBaseUrl = (fallbackBase = "") => {
  const explicitBase = trimTrailingSlashes(process.env.REACT_APP_TRANSCRIBE_BASE_URL || "");
  return explicitBase || trimTrailingSlashes(fallbackBase);
};

export const getRealtimeRelayWsUrl = (fallbackBase = "") => {
  const explicitWsUrl = trimTrailingSlashes(process.env.REACT_APP_TRANSCRIBE_WS_URL || "");
  if (explicitWsUrl) return explicitWsUrl;

  const relayBase = getRealtimeRelayBaseUrl(fallbackBase);
  return relayBase ? `${relayBase}/transcribe` : "";
};
